import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Button, ModalWindow, ModalFullscreen } from '@cian/ui-kit';
import * as styles from './ModalConfirm.css';
import { Loader } from '../Loader';
export function ModalConfirm(_ref) {
  var onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      fullScreen = _ref.fullScreen,
      header = _ref.header,
      isVisible = _ref.isVisible,
      isLoading = _ref.isLoading,
      text = _ref.text,
      fixed = _ref.fixed,
      children = _ref.children,
      confirmButtonDisabled = _ref.confirmButtonDisabled,
      onOpen = _ref.onOpen;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isButtonLoading = _React$useState2[0],
      setIsButtonLoading = _React$useState2[1];

  React.useEffect(function () {
    if (onOpen) {
      onOpen();
    }
  }, []);

  var handleConfirm = function handleConfirm() {
    setIsButtonLoading(true);
    onConfirm();
  };

  var content = /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(text) && /*#__PURE__*/React.createElement("div", {
    className: styles['text']
  }, text), isLoading ? /*#__PURE__*/React.createElement(Loader, null) : children);
  var footer = /*#__PURE__*/React.createElement("div", {
    className: styles['footer']
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "fill_white_primary",
    size: "XS",
    onClick: onCancel
  }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Button, {
    loading: isButtonLoading,
    disabled: confirmButtonDisabled || isLoading,
    size: "XS",
    onClick: handleConfirm
  }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"));

  if (fullScreen) {
    return /*#__PURE__*/React.createElement(ModalFullscreen, {
      onClose: onCancel,
      open: isVisible
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['wrapper']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['header-wrapper']
    }, header), /*#__PURE__*/React.createElement("div", {
      className: styles['content-wrapper']
    }, content), /*#__PURE__*/React.createElement("div", {
      className: styles['footer-wrapper']
    }, footer)));
  }

  return /*#__PURE__*/React.createElement(ModalWindow, {
    fixed: Boolean(fixed),
    header: header,
    content: content,
    footer: footer,
    size: "XS",
    width: 400,
    onClose: onCancel,
    open: isVisible
  });
}